import { Controller } from '@hotwired/stimulus'
import { useIntersection } from 'stimulus-use'

import { track, trackSegment, sendFbClick, datalayerPush } from '../utils/track'
import { ADALYSER_EVENT_NAME, CLICK_EVENT_NAME, ECOMM_EVENT_NAME } from '~/components/tracking/ecommerce'
import getWindow from '~/utils/get-window'

export default class TrackingController extends Controller {
  static values = {
    event: String,
    properties: Object
  }

  connect() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useIntersection(this)
  }

  appear(entry) {
    if (this.eventValue) {
      const formSrc = entry.target.getAttribute('data-src')
      const formSrcId = entry.target.getAttribute('data-src-id')
      trackSegment(this.eventValue, {
        ...this.propertiesValue,
        form_id: formSrc || this.propertiesValue.form_id,
        form_name: formSrc || this.propertiesValue.form_name,
        form_started_id: formSrcId || this.propertiesValue.form_started_id
      })
    }
  }

  track(e) {
    const { event, label, value } = e.params

    track(event, label, value)
  }

  trackSegment(e) {
    const { event, properties } = e.params

    trackSegment(event, properties)
  }

  sendFbClick() {
    sendFbClick()
  }

  trackClickout(e) {
    const {
      properties: {
        ecommerce: { comparisonId, ...ecommerce },
        deal,
        list,
        position
      }
    } = e.params

    datalayerPush({
      action: 'clickout',
      customerID: getWindow().__uswitchUserId__,
      event: ADALYSER_EVENT_NAME,
      product: 'broadband',
      type: 'adalyser',
      value: 0
    })

    datalayerPush({
      event: ECOMM_EVENT_NAME,
      ecommerce: {
        currencyCode: 'GBP',
        click: {
          actionField: { list },
          products: [
            {
              position,
              name: deal.title,
              id: deal.productId.toString(),
              brand: deal.provider.name,
              variant: deal.id,
              dimension86: deal.id,
              dimension87: `${comparisonId}-${deal.id}`,
              dimension91: comparisonId,
              ...ecommerce
            }
          ]
        }
      }
    })

    datalayerPush({ event: CLICK_EVENT_NAME })
  }
}
